import { render, staticRenderFns } from "./VerifyCodeDialog.vue?vue&type=template&id=4c3a1fa7"
import script from "./VerifyCodeDialog.vue?vue&type=script&lang=ts"
export * from "./VerifyCodeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports